import { useEffect } from 'react';

// Sets the document title and meta description per page (SPA equivalent of
// per-page <title> tags). Keep titles under ~60 chars for search results.
export const usePageMeta = (title: string, description: string) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', description);
    }
  }, [title, description]);
};
